__turbopack_context__.v({
  "guide": "IrregularSample-module__dKy4aq__guide",
  "line": "IrregularSample-module__dKy4aq__line",
  "svg": "IrregularSample-module__dKy4aq__svg",
  "tip": "IrregularSample-module__dKy4aq__tip",
  "wrap": "IrregularSample-module__dKy4aq__wrap",
});
